import { createContext, useContext, useEffect, useState } from "react";

const SidebarContext = createContext({ isOpen: true, toggle: () => {}, close: () => {} });

export function SidebarProvider({ children }) {
  // Por defecto: abierto en desktop, cerrado en mobile/tablet.
  const initial = typeof window !== "undefined" ? window.innerWidth >= 1024 : true;
  const [isOpen, setIsOpen] = useState(() => {
    try {
      const saved = localStorage.getItem("sidebarOpen");
      if (saved !== null) return saved === "1";
    } catch { /* ignore */ }
    return initial;
  });

  useEffect(() => {
    try { localStorage.setItem("sidebarOpen", isOpen ? "1" : "0"); } catch { /* ignore */ }
  }, [isOpen]);

  // Cierra el sidebar al cambiar de ruta en mobile/tablet (lo manejamos por click)
  const close = () => setIsOpen(false);
  const open = () => setIsOpen(true);
  const toggle = () => setIsOpen((v) => !v);
  return (
    <SidebarContext.Provider value={{ isOpen, toggle, close, open }}>
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
